import { CallCenterDefault } from 'components/features'
import { CrashSafeWrapper } from '../components/CrashSafeWrapper'

const CallCenter = () => {
  return (
    <CrashSafeWrapper level="page" name="CallCenter">
      <CallCenterDefault/>
    </CrashSafeWrapper>
  )
}

export default CallCenter
